export const loadZendeskSnippet = (key: string) => {
    const script = document.createElement('script');
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${key}`;
    script.id = 'ze-snippet';
    script.defer = true;
    document.head.appendChild(script);
};

export default loadZendeskSnippet;
